// @ts-nocheck

import React, { ReactNode, useContext } from "react";
import cn from "classnames";

import globalFormStyles from "../global.formElements.module.scss";
import FieldMessage from "../FieldMessage";
import { CheckboxGroupProps } from "./CheckboxGroup.props";
import LabelTextItem from "../../LabelTextItem";
import Label from "../Label";
import Checkbox from "../Checkbox";

import { FormContext, useFormField } from "../../Form";

/**
 * @deprecated Use `import { CheckboxGroup } from capitalrx-components-2.0/lib/forms` instead.
 */
const CheckboxGroup: React.FC<CheckboxGroupProps> = (props: CheckboxGroupProps) => {
  const {
    children,
    name,
    id,
    label,
    validate,
    helperText,
    disabled,
    displayReadOnlyFieldInline,
    large,
    containerClassName,
    onChange,
    readOnly,
    useAsterisk,
    childrenClassName,
    isLoading,
  } = props;

  const { formState, readOnly: readOnlyForm } = useContext(FormContext);
  const { errors, isFormLoading } = formState;

  const fieldValue = useFormField(name);

  const checkboxContainerClass = cn(globalFormStyles["form-field-container"], containerClassName);
  const displayLabel = label && <Label id={`label-${id}`} label={label} validate={validate} useAsterisk={useAsterisk} />;
  const readyOnlyStyles = cn({ [globalFormStyles["selection-field-read-only"]]: !displayReadOnlyFieldInline });
  const childrenClasses = cn(globalFormStyles["selection-field-children-container"], childrenClassName);

  const renderChildrenWithProps = (child: ReactNode): ReactNode => {
    if (React.isValidElement(child) && child.type === Checkbox) {
      return React.cloneElement(child, {
        id: `${id}-${child.props.value.split(" ").join("-").toLowerCase()}`,
        errors,
        validate,
        helperText,
        name: name,
        large: large,
        value: child?.props?.value,
        disabled: disabled ? disabled : child.props.disabled,
        label: child.props.label,
        isLoading: isLoading || isFormLoading,
        isChecked: fieldValue && fieldValue?.includes(child?.props?.value),
      });
    }
    return child;
  };

  let component = null;
  if (readOnly || readOnlyForm) {
    const checkboxValue = fieldValue && new Array(String(fieldValue)).filter(Boolean).join("\r\n");
    component = (
      <LabelTextItem
        id={id}
        label={label}
        displayInline={displayReadOnlyFieldInline}
        body={checkboxValue}
        isLoading={isLoading || isFormLoading}
        className={readyOnlyStyles}
      />
    );
  } else {
    component = (
      <>
        {displayLabel}
        <div className={childrenClasses} onChange={onChange}>
          {React.Children.map(children, (child: ReactNode) => {
            return renderChildrenWithProps(child);
          })}
        </div>
        <FieldMessage id={id} helperText={helperText} errors={errors} name={name} />
      </>
    );
  }

  return <div className={checkboxContainerClass}>{component}</div>;
};

/**
 * @deprecated
 */
export default CheckboxGroup;
